module.exports = __webpack_public_path__ + "img/5.c2559dd5.gif";